<div class="news" (click)="visitNewsSource(config.sourceLink)">
  <div class="image-container">
    <img *ngIf="imagePath" [src]="imagePath" [alt]="config.title + ' cover photo'">
  </div>
  <div class="content" notranslate>
    <h5>{{config.title}}</h5>
    <a *ngIf="config.sourceLink" [href]="config.sourceLink" target="_blank" rel="noopener" (click)="$event.stopPropagation()"><span class="caption">{{config.description}}</span></a>
    <span *ngIf="!config.sourceLink" class="caption">{{config.description}}</span>
  </div>
</div>
